import { render, staticRenderFns } from "./RelatorioHistoricoMatriculaForm.vue?vue&type=template&id=0d5eec0d&scoped=true&"
import script from "./RelatorioHistoricoMatriculaForm.vue?vue&type=script&lang=js&"
export * from "./RelatorioHistoricoMatriculaForm.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioHistoricoMatriculaForm.vue?vue&type=style&index=0&id=0d5eec0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5eec0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRadio,VRadioGroup,VRow,VTextField})
